export default __webpack_public_path__ + "static/media/AdobeStock_166474053.c93b46e6.jpg";